import PropTypes from "prop-types";
import moreIcon from "../../../assets/vectors/more-1.svg";
import ImageDropdown from "../../dropdowns/image-dropdown/image-dropdown.component";
import AlignedImageBox2 from "../../image-boxes/aligned-image-box/aligned-image-box-2";
import ProfileDropdownMenu from "../../menus/profile-dropdown-menu/profile-dropdown-menu.component";

import { VscCopy } from "react-icons/vsc";

import { ReactComponent as Edit2Svg } from "../../../assets/vectors/edit-2.svg";
import { ReactComponent as TrashSvg } from "../../../assets/vectors/trash.svg";
import { ReactComponent as ShareSvg } from "../../../assets/vectors/share.svg";
import { nairaFormart } from "../../../utils/functions";

const MyPropertyCardItem = ({ data, sn }) => {
  const isPending = data?.status === "pending" || data?.post_status === "pending";

  const ItemList = [
    {
      title: <span className={isPending ? "opacity-50 cursor-not-allowed" : ""}>Edit</span>,
      icon: <Edit2Svg className={`inline-block mr-2 h-4 ${isPending ? "opacity-50" : ""}`} />,
      path: "?action=edit&id=" + parseInt(data?.id),
    },
    {
      title: "Share",
      icon: <ShareSvg className="inline-block mr-2 pr-[1px] h-4" />,
      path: "?action=share&id=" + parseInt(data?.id),
    },
    {
      title: "Copy payment link",
      icon: <VscCopy className="inline-block mr-2 h-4" />,
      path: "?action=copy&id=" + parseInt(data?.id),
    },
    {
      title: <span className={isPending ? "opacity-50 cursor-not-allowed" : ""}>Delete</span>,
      icon: <TrashSvg className={`inline-block -ml-1 mr-1 h-4 ${isPending ? "opacity-50" : ""}`} />,
      path: "?action=delete&id=" + parseInt(data?.id),
    },
  ];

  return (
    <div className="relative w-full flex flex-col md:flex-row md:items-center gap-3 md:gap-5 mt-4 md:mt-8 p-4 md:p-0 bg-white md:bg-transparent border md:border-none border-gray-100 rounded-xl md:rounded-none shadow-sm md:shadow-none text-[14px] font-light">
      
      <div className="hidden md:block w-[3%]">{sn}</div>
      
      <div className="w-full md:w-[22%] min-w-0 pr-8 md:pr-0">
        <AlignedImageBox2
          profileImage={data?.acf?.photo_gallery?.gallery?.[0]?.[0]?.full_image_url}
          text={data?.title}
          subtext={data?.property_type}
        />
      </div>
      
    <p className="w-full md:w-[20%] min-w-0 text-gray-500 md:text-black text-xs md:text-sm md:truncate">
        {data?.acf?.address}
      </p>

      <div className="flex items-center justify-between w-full mt-2 md:mt-0 md:contents">
        <div className="w-auto md:w-[15%] font-medium md:font-light text-primary md:text-black text-base md:text-[14px]">
          {nairaFormart(data?.acf?.price)}
        </div>
        
        {isPending ? (
          <div className="w-auto md:w-[20%] md:text-center">
            <span className="text-yellow-700 bg-yellow-100 font-bold py-1 px-4 rounded-2xl text-[10px] md:text-xs whitespace-nowrap">
              Under Review
            </span>
          </div>
        ) : data?.acf?.occupancy_status && data?.acf?.occupancy_status === true ? (
          <div className="w-auto md:w-[20%] md:text-center">
            <span className="text-green-700 bg-green-100 font-normal py-1 px-4 rounded-2xl text-xs md:text-sm">
              Occupied
            </span>
          </div>
        ) : (
          <div className="w-auto md:w-[20%] md:text-center">
            <span className="text-stone-700 bg-stone-200 font-normal py-1 px-4 rounded-2xl text-xs md:text-sm">
              Unoccupied
            </span>
          </div>
        )}
      </div>

      <div className="absolute top-4 right-4 md:static md:w-[10%] flex md:justify-start">
        <ImageDropdown
          panelElement={<ProfileDropdownMenu menuItemList={ItemList} />}
          image={{ src: moreIcon, size: 24 }}
          nocaretIcon={" "}
          appendClass={"right-0 md:-translate-x-[28%] md:-mt-[2px]"}
        />
      </div>
    </div>
  );
};

MyPropertyCardItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    property_type: PropTypes.string,
    status: PropTypes.string,
    post_status: PropTypes.string,
    acf: PropTypes.shape({
      photo_gallery: PropTypes.object,
      address: PropTypes.string,
      price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      occupancy_status: PropTypes.bool,
    }),
  }).isRequired,
  sn: PropTypes.number.isRequired,
};

export default MyPropertyCardItem;